import React from 'react';
import '../styles/Quote.css';

const Quote = () => (
  <>
    <section className="container quote-section">
      <h2>
        <q>
          Mathematics is not about numbers, equations, computations, or
          algorithms: it is about understanding.
        </q>
        <span>- William Paul Thurstion.</span>
      </h2>
    </section>
  </>
);

export default Quote;
